export const UPDATED = 'simplecasino/game-providers/UPDATED'
